$(document).ready(function () {
    let hostname = window.location.origin;

    /*------ CHECK HOSTNAME ------*/

    if (hostname == 'https://localhost' || hostname == 'http://localhost') {
        hostname += '/portailV1/public'
    }

    /*------ AUTOCOMPLETE -------*/

    $('#autocomplete').autocomplete({
        source: route('autocompleteCustomer'),
        minLength: 3,
        autoFocus: true
    });


});